import {
    SNAPCHAT_PIXEL_TRACK,
    SNAPCHAT_PIXEL_VIEW,
} from '_constants/snapchatPixel';
import {
    SnapchatAdvancedMatchShape,
    SnapchatData,
    SnapchatPurchaseDataShape,
} from '.';

type TrackDataShape = { [key: string]: string | number };

type SnaptrShape = (
    _arg0: string,
    _arg1: string,
    _arg3:
        | SnapchatAdvancedMatchShape
        | TrackDataShape
        | SnapchatData
        | SnapchatPurchaseDataShape,
) => void;

declare global {
    interface Window {
        snaptr?: SnaptrShape;
    }
}

/**
 * Gets snaptr object from window, if this is set
 * returns undefined and logs error if it isn't yet initialized
 */
const getSnaptr = (): SnaptrShape | undefined => {
    const snaptr = window.snaptr;
    if (!snaptr) {
        console.warn(
            'Snapchat pixel is not yet initialized. Could be because of adblock',
        );
        return undefined;
    }
    return snaptr;
};

const SnapchatPixel = {
    /**
     * Initializes the pixel with the given id and eventual email
     */
    init(
        pixelId: string,
        advancedMatch: SnapchatAdvancedMatchShape | null = null,
    ): void {
        /* eslint-disable */
        (function (e, t, n) {
            if (e.snaptr) return;
            var a = (e.snaptr = function (): typeof a {
                a.handleRequest
                    ? a.handleRequest.apply(a, arguments)
                    : a.queue.push(arguments);
            });
            a.queue = [];
            var s = 'script';
            var r = t.createElement(s) as HTMLScriptElement;
            r.async = !0;
            r.src = n;
            var u = t.getElementsByTagName(s)[0];
            u?.parentNode?.insertBefore(r, u);
        })(window, document, 'https://sc-static.net/scevent.min.js');
        /* eslint-enable */

        if (!pixelId) {
            console.error('Please insert pixel id for initializing');
            return;
        }
        const snaptr = getSnaptr();
        if (snaptr) {
            snaptr('init', pixelId, advancedMatch ?? {});
        }
    },

    /**
     * Tracks PageView
     */
    pageView(): void {
        const snaptr = getSnaptr();
        if (snaptr) {
            snaptr(SNAPCHAT_PIXEL_TRACK, SNAPCHAT_PIXEL_VIEW, {});
        }
    },

    /**
     * Track snapchat event
     */
    track(event: string, data: SnapchatData | SnapchatPurchaseDataShape): void {
        const snaptr = getSnaptr();
        if (snaptr) {
            snaptr(SNAPCHAT_PIXEL_TRACK, event, data);
        }
    },
};

export default SnapchatPixel;
